var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formholder"},[_c('div',{staticClass:"formholder1",style:({height:_vm.property.height+'px'})}),(_vm.property.radio==1)?_c('div',{staticClass:"formholderline"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }